<h2 mat-dialog-title>{{ title }}</h2>
<div mat-dialog-content>
  <p>{{ message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button (click)="dialogRef.close(false)">{{ 'cancel' | translate }}</button>
  <button mat-flat-button color="warn" (click)="dialogRef.close(true)">{{ 'yes' | translate }}</button>
</div>
